import React, {Component} from 'react';
import BGVideo  from "../assets/videos/telcarnet.mp4"
import Logo from "../assets/images/logo.png";
import {toast} from "react-toastify";
import Toast from "./Common/Toast";


String.prototype.hashCode = function() {
    let hash = 0,
        i, chr;
    if (this.length === 0) return hash;
    for (i = 0; i < this.length; i++) {
        chr = this.charCodeAt(i);
        hash = ((hash << 5) - hash) + chr;
        hash |= 0; // Convert to 32bit integer
    }
    return hash;
}




class Splash extends Component {

    state = {

        appOldPass : "",
        buttonStatus:   "disabled",
        buttonText : "ورود به سامانه",
        loading: "d-none",
        message: "",
        showPasswordBox : false
    }

    onInputChange = (val) => {

        const inputName = val.target.name;
        this.setState({[inputName]: val.target.value});
    }
    setAppPass = () => {
        const oldPass = window.localStorage.getItem("_fToken");
        const currentPass = this.state.appOldPass.hashCode().toString()

        if(oldPass && oldPass !== currentPass) {
            toast.error('پسورد صحیح نمی باشد')
        }
        else {
            this.props.history.push("/home") ;
        }


    }


    render() {
        return (
           <section className="container bg-primary-color vh-100 ">
               <Toast/>
               <div className="row text-center">
                   <div className="col-12 pt-5">
                       <video autoPlay muted loop playsInline id="video-bg" data-wf-ignore="true"
                              data-object-fit="cover"  >
                           <source src={BGVideo} type="video/mp4" />
                       </video>
                       <div className="col-12 text-center mt-3 fixed-top">
                           <img src={Logo} alt="Logo" width={110} className='splash-logo'/>
                       </div>

                       {
                           this.state.showPasswordBox &&

                           <div className="col-12 mt-5 splash-password">
                               <div className="form-floating col-12 mt-5">
                                   <input type="password"
                                          className="form-control px-5 bg-transparent text-white text-right "
                                          id="appOldPass" name="appOldPass"
                                          placeholder="پسورد کنونی"
                                          onChange={this.onInputChange}
                                          value={this.state.appOldPass}

                                   />
                                   <label htmlFor="appPass" className="ms-2 text-light right-0 small">
                                       پسورد ورود به سامانه

                                   </label>


                               </div>
                               <div className="col-12 my-2 ">
                                   <button className='btn btn-outline-info text-white
                                        text-small-1 w-100 p-2'
                                           onClick={this.setAppPass}
                                   >
                                     ورود به سامانه
                                   </button>
                               </div>
                           </div>

                       }
                   </div>

                   <div className="col-12 text-center fixed-bottom mb-3 splash-bottom">
                       <div className="spinner-grow text-white" role="status">

                       </div>
                   </div>
               </div>
           </section>
        );
    }
    componentDidMount = () => {
        let splashTime = window.localStorage.getItem("_trk" );

        if(!splashTime) {
            splashTime = 3400;
        }

        setTimeout(() => {
            const mobile = window.localStorage.getItem("mobile");
            const password = window.localStorage.getItem("password");
            const ac = window.localStorage.getItem("_ac" );
            if(!ac) {
                window.localStorage.setItem("_ac" , 0);
            }

            window.localStorage.setItem("_sP" , 'MN8956');

            if(!mobile && !password ) {
                window.location.replace('/register')
            }
            else {
                const oldPass = window.localStorage.getItem("_fToken");
                if(oldPass) {
                    this.setState({
                        showPasswordBox : true
                    })
                }
                else{
                    this.props.history.push("/home") ;
                }

            }

        }, splashTime);

    }
}

export default Splash;